import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { InternRouter } from '@app/const';
import { AppStore } from '@app/models';
import { ModalProvider, StoreProvider } from '@app/providers';
import { LocalBusinessesServices } from '@app/services';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Subscription } from 'rxjs';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-nav-bar-tabs',
    templateUrl: './nav-bar-tabs.component.html',
    styleUrls: ['./nav-bar-tabs.component.scss'],
})
export class NavBarTabsComponent implements OnInit, OnDestroy {
    public pageActive: any = false;
    public oldPageActive: string = '';
    public modal: NgbModalRef | boolean = false;
    public settings: any = null;
    public settingsLoaded: boolean = false;

    @Input() isLogged: boolean = true;

    public navItems: {
        name?: string;
        img?: string;
        url: string;
        isHome?: boolean;
        modalName?: string;
        urlAlias?: string;
    }[] = InternRouter;

    private onCloseSub$!: Subscription;
    private settingsSub$!: Subscription;

    constructor(
        private router: Router,
        private modalProvider: ModalProvider,
        private localBusinessesService: LocalBusinessesServices,
        private store: StoreProvider,
        private cdr: ChangeDetectorRef
    ) {}

    public isActive(url: any) {
        return this.pageActive && this.pageActive.includes(url);
    }

    ngOnInit(): void {
        this.pageActive = this.router.url;
        this.oldPageActive = this.router.url;

        this.onCloseSub$ = this.modalProvider
            .listenClose()
            .subscribe((event) => {
                if (event) {
                    this.pageActive = this.router.url;
                }
            });

        this.settingsSub$ = this.store.settings$.subscribe({
            next: (settings) => {
                this.settings = settings;
                this.settingsLoaded = true;
                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error('Erreur chargement settings:', err);
            },
        });
    }

    public goPage(item: any) {
        if (!this.isLogged) return;
        this.pageActive = item.url;
        this.oldPageActive = item.url;
        this.router.navigate([item.url]);
        this.store.emitReloadAll(true);

        if (item.navDetail) {
            this.store.emit({
                app: {
                    props: {
                        detailNav: {
                            items: item.navDetail,
                            active: item.navDetail[
                                Math.trunc(item.navDetail.length / 2)
                            ],
                        },
                    },
                },
            });
        }
    }

    public openModal(item: any) {
        if (!this.isLogged) return;
        this.pageActive = item.url;
        this.modal = this.modalProvider.open(item.modalName as any, {
            scrollable: false,
            modalDialogClass: 'localbusinesses-modal-content h-100',
        });

        firstValueFrom(this.modal.dismissed).then(() => {
            this.pageActive = this.oldPageActive;
        });
    }

    public isNavItemDisabled(index: number): boolean {
        if (!this.settingsLoaded) return false;
        const isLast = index === this.navItems.length - 1;
        return isLast && !this.settings?.journey;
    }

    ngOnDestroy(): void {
        this.onCloseSub$?.unsubscribe();
        this.settingsSub$?.unsubscribe();
    }
}
